import { render } from "./LoadingCpaps.vue?vue&type=template&id=117ea13c&scoped=true"
import script from "./LoadingCpaps.vue?vue&type=script&lang=js"
export * from "./LoadingCpaps.vue?vue&type=script&lang=js"

import "./LoadingCpaps.vue?vue&type=style&index=0&id=117ea13c&scoped=true&lang=scss"

import exportComponent from "/home/cpaps/sistema-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-117ea13c"]])

export default __exports__